// 処方せん発行時期と、土日診察の薬局受け取り注意を同じ見た目で並べる (#1191 #1192)
// 夜間枠: 22時以降開始の診察は処方せん発行・お会計が翌営業日になる（発行予定日の案内を内包する）
// 発行予定日: クリニック営業日の都合で発行が翌日以降になるとき
// 薬局注意: 土曜12:00以降・日曜の診察は薬局への処方せん送付を週明けに行うため、受け取りがその日以降になるとき
// 文言・出し分けの変更が画面ごとに漏れないよう1箇所に集約する
type Props = {
  nightSlot?: boolean
  expectedPrescriptionIssuedDate?: string | null
  pharmacyReceivableFrom?: string | null
  className?: string
}

export default function PrescriptionNotice({
  nightSlot = false,
  expectedPrescriptionIssuedDate,
  pharmacyReceivableFrom,
  className = '',
}: Props) {
  if (!nightSlot && !expectedPrescriptionIssuedDate && !pharmacyReceivableFrom) return null

  return (
    <div className={`text-xs font-bold text-orange-600 ${className}`}>
      {nightSlot ? (
        <p>※夜間の診察のため、処方せんの発行・お会計は翌営業日{expectedPrescriptionIssuedDate && `（${expectedPrescriptionIssuedDate}）`}となります</p>
      ) : (
        expectedPrescriptionIssuedDate && <p>※処方せんの発行は{expectedPrescriptionIssuedDate}となります</p>
      )}
      {pharmacyReceivableFrom && <p>※お薬のお受け取りは{pharmacyReceivableFrom}以降になります</p>}
    </div>
  )
}
